import * as React from 'react';

import { ColumnDefinition, SORT_STATE, Table } from '@abb/common-ux';

import { ISiteModel, ISitesState, ISortingSettings } from '@module/shared/components/Site/models';

/* tslint:disable:jsx-no-lambda */
export default class Sites extends React.Component<any, any> {
    public render() {
        const SiteTableColumn = ColumnDefinition as new () => ColumnDefinition<ISiteModel>;
        const { sites, sortingSettings } = this.props;

        if (this.props.sites.length > 0 || this.props.sitesLoading) {
            return (
                <Table data={sites} hover={true} emptyMessage='Loading ..' navigateColumn={(row: any) => { this.props.history.push(`/Licenses/${row.siteId}`); }} sortedColumnName={sortingSettings.sortField} sortedColDirection={sortingSettings.sortDirection} headerClick={this.props.sortField}>
                    <SiteTableColumn cell={(row) => row.name} header='Site Name' columnName='SiteName' />
                    <SiteTableColumn cell={(row) => row.servIsId.toString()} header='ServIS ID' columnName='ServIsId' />
                    <SiteTableColumn cell={(row) => row.customer} header='Customer (Owner)' columnName='Owner' />
                    <SiteTableColumn cell={(row) => row.region} header='Region' columnName='RegionName' />
                </Table>
            );
        } else {
            if (this.props.searchFilter.length > 0) {
                return (
                    <div>
                        <p>No results found based on provided search criteria.</p>
                        <p>Make sure all words are spelled correctly.</p>
                        <p>Try again or contact customer Support at <a href='mailto:us-iasvsupport@abb.com'>us-iasvsupport@abb.com.</a></p>
                    </div>
                );
            } else {
                return (
                    <div>
                        <p>At this time, you do not have permission to view any sites.</p>
                        <p>Contact customer Support at <a href='mailto:us-iasvsupport@abb.com'>us-iasvsupport@abb.com</a> to gain access.</p>
                    </div>
                );
            }
        }
     }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/site/components/Sites.tsx